<template>
  <div class="row">
    <div class="col-12">
        <div class="card card-body">
            <b-modal id="create" title="اضافة/تعديل" hide-footer size="lg">
                <div class="form-group">
                  <h5 for="">العنوان</h5>
                  <input type="text"
                    class="form-control" v-model="current.title" placeholder="اكتب هنا...">
                </div>
                <div class="form-group">
                  <h5 for="">الوصف</h5>
                  <input type="text"
                    class="form-control" v-model="current.details" placeholder="اكتب هنا...">
                </div>
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-bordered table-sm">
                        <thead>
                            <th>
                                الحقل
                                <button class="btn btn-sm btn-success" @click="current.inputs.push({
                                    code: Math.random().toString().split('.')[1],
                                    title: '',
                                    type: 'text',
                                    values: []
                                }); refresh()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </th>
                            <th>
                                النوع
                            </th>
                            <th>
                                القيم
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="input in current.inputs" :key="input.code">
                                <td style="padding: 0px">
                                    <input type="text" style="border-radius: 0px" v-model="input.title" class="form-control" placeholder="اكتب هنا...">
                                </td>
                                <td style="padding: 0px">
                                    <select type="text" style="border-radius: 0px" v-model="input.type" class="form-control">
                                        <option value="text">نص</option>
                                        <option value="radio">اختيار من متعدد</option>
                                        <option value="checkbox">عدة اختيارات</option>
                                    </select>
                                </td>
                                <td style="padding: 0px">
                                    <textarea type="text" v-if="input.type == 'checkbox' || input.type == 'radio'" style="border-radius: 0px" v-model="input.values" class="form-control" placeholder="كل قيمة في سطر"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 text-center g">
                    <button class="btn btn-primary" @click="addNow()" v-if="!edit">
                        اضافة
                    </button>
                    <button class="btn btn-primary" @click="editNow()" v-if="edit">
                        تعديل
                    </button>
                </div>
            </b-modal>

                <b-modal id="endsz" title="عرض" hide-footer size="lg">
                    <div class="col-12 g" style="margin-bottom: 10px;" v-if="ends.length">
                        <h6 v-if="currentAsk.title" style="margin-bottom: 8px;">{{ currentAsk.title }}</h6>
                        <button class="btn btn-sm btn-primary" @click="printEnds()" style="margin-left: 5px;">
                            <i class="fa fa-print"></i> طباعة
                        </button>
                        <button class="btn btn-sm btn-success" @click="exportEnds()">
                            <i class="fa fa-download"></i> تصدير Excel
                        </button>
                    </div>
                    <div class="col-12 table-responsive">
                        <table class="table-hover table table-bordered table-sm">
                            <thead>
                                <th>
                                    الحاج
                                </th>
                                <th>
                                    تاريخ الاجابة
                                </th>
                                <th>
                                    الحقول
                                </th>
                            </thead>
                            <tbody>
                                <tr v-for="end in ends" :key="end.number">
                                    <td>
                                        {{ end.name }}
                                    </td>
                                    <td>
                                        {{ end.date }}
                                    </td>
                                    <td>
                                        <button class="btn btn-sm text-danger" style="padding: 0px" @click="viewx(`.c_${end.number+end.code}`)"><i class="fa fa-eye"></i> عرض ({{JSON.parse(end.inputs).length}})</button>
                                        <ul :class="`dnone c_${end.number+end.code}`">
                                            <br>
                                            <li v-for="(a) in JSON.parse(end.inputs)" :key="a.code">
                                                {{ a.title }}: {{a.value}}
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-modal>
            <h5>
                الاسبيانات <button class="btn btn-success" @click="current = {inputs: []}; edit = false;" v-b-modal.create style="padding: 5px; border-radius: 50%;">
                    <i class="fa fa-plus"></i>
                </button>
            </h5>
            <div class="col-12 table-responsive" style="padding: 0px">
                <table class="table table-hover table-bordered table-sm">
                    <thead>
                        <th>
                            العنوان
                        </th>
                        <th>
                            تاريخ الانشاء
                        </th>
                        <th>
                            عدد من انهى
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="item in list" :key="item._id">
                            <td>
                                {{ item.title }}
                            </td>
                            <td>
                                {{ item.date }}
                            </td>
                            <td>
                                <button class="btn btn-sm btn-outline-default text-danger" v-b-modal.endsz @click="ends = item.ends; currentAsk = item" style="padding: 0px">
                                    {{ item.ends.length }}
                                    <i class="fa fa-eye"></i>
                                </button>
                            </td>
                            <td>
                                <button class="btn btn-sm btn-success" @click="edit = true; current = item" v-b-modal.create>
                                    <i class="fa fa-edit"></i>
                                </button>
                                <button class="btn btn-sm btn-danger" @click="deleteNow(item._id)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {  VBModal, BModal, BDropdown, BDropdownItem } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import * as XLSX from "xlsx";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    BModal
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
    data(){
        return {
            current: {inputs: []},
            user: JSON.parse(localStorage.getItem("user")),
            canAdd: checkPer('ques'),
            list: [],
            ends: [],
            currentAsk: {},
            edit: false
        }
    },
    created(){
        var g = this;
        if(!g.canAdd){
            g.$router.push('/pers')
            return;
        }
        g.gett()
    },
    methods: {
        refresh(){
            this.current = JSON.parse(JSON.stringify(this.current))
        },
        viewx(x){
            $(x).toggle()
        },
        gett(){
            var g = this;
            $.post(api + '/admin/asks/list', {
                jwt: g.user.jwt
            }).then(function(r){
                g.list = r.response.map(function(x){
                    x.inputs = JSON.parse(x.inputs)
                    return x;
                });
            })
        },
        addNow(){
            var g = this;
            $.post(api + '/admin/asks/create', {
                jwt: g.user.jwt,
                title: g.current.title,
                details: g.current.details,
                inputs: JSON.stringify(g.current.inputs)
            }).then(function(r){
                g.gett()
                alert("تم بنجاح", 100)
            })
        },
        editNow(){
            var g = this;
            $.post(api + '/admin/asks/edit', {
                jwt: g.user.jwt,
                id: g.current._id,
                title: g.current.title,
                details: g.current.details,
                inputs: JSON.stringify(g.current.inputs)
            }).then(function(r){
                g.gett()
                alert("تم بنجاح", 100)
            })
        },
        deleteNow(id){
            var g = this;
            if(confirm("متأكد من الحذف؟")){
                $.post(api + '/admin/asks/delete', {
                    jwt: g.user.jwt,
                    id: id
                }).then(function(r){
                    g.gett()
                })
            }
        },
        // تحويل قيمة الاجابة الى نص (تدعم الاختيارات المتعددة)
        answerText(value){
            if(Array.isArray(value)){
                return value.join('، ');
            }
            return (value === null || value === undefined || value === '') ? '—' : String(value);
        },
        // هروب رموز HTML لنافذة الطباعة
        esc(s){
            return String(s === null || s === undefined ? '' : s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },
        // طباعة اجابات الاستبانة بتنسيق مناسب للاسئلة الطويلة
        printEnds(){
            var g = this;
            var title = g.currentAsk.title || 'الاستبانة';
            var details = g.currentAsk.details || '';
            var body = '';
            g.ends.forEach(function(end, idx){
                var inputs = [];
                try { inputs = JSON.parse(end.inputs); } catch(e) { inputs = []; }
                var qa = inputs.map(function(a){
                    return '<div class="qa">' +
                                '<div class="q">' + g.esc(a.title) + '</div>' +
                                '<div class="a">' + g.esc(g.answerText(a.value)) + '</div>' +
                           '</div>';
                }).join('');
                body += '<section class="resp">' +
                            '<div class="resp-head">' +
                                '<span class="resp-no">#' + (idx + 1) + '</span>' +
                                '<span class="resp-name">' + g.esc(end.name) + '</span>' +
                                '<span class="resp-date">' + g.esc(end.date) + '</span>' +
                            '</div>' +
                            qa +
                        '</section>';
            });
            var css =
                '@page { margin: 6mm 7mm; }' +
                '* { box-sizing: border-box; }' +
                'body { font-family: "Tahoma","Cairo",sans-serif; direction: rtl; color: #222; margin: 0; font-size: 9px; }' +
                'h1 { font-size: 13px; margin: 0 0 2px; }' +
                '.details { color: #555; margin: 0 0 3px; font-size: 9px; }' +
                '.count { color: #777; font-size: 8px; margin-bottom: 6px; border-bottom: 1px solid #333; padding-bottom: 3px; }' +
                '.resp { border: 1px solid #ccc; border-radius: 4px; padding: 5px 7px; margin-bottom: 0; page-break-inside: avoid; page-break-after: always; }' +
                '.resp:last-child { page-break-after: auto; }' +
                '.resp-head { display: flex; justify-content: space-between; gap: 6px; flex-wrap: wrap; background: #f3f3f3; margin: -5px -7px 6px; padding: 4px 7px; border-bottom: 1px solid #ddd; font-weight: bold; font-size: 9.5px; }' +
                '.resp-no { color: #888; }' +
                '.resp-date { color: #666; font-weight: normal; }' +
                '.qa { margin-bottom: 4px; padding-bottom: 4px; border-bottom: 1px dashed #e0e0e0; }' +
                '.qa:last-child { border-bottom: 0; margin-bottom: 0; padding-bottom: 0; }' +
                '.q { font-weight: bold; font-size: 9px; line-height: 1.3; margin-bottom: 1px; word-wrap: break-word; }' +
                '.a { font-size: 9px; line-height: 1.3; color: #1a4; word-wrap: break-word; white-space: pre-wrap; }';
            var doc = '<!DOCTYPE html><html dir="rtl" lang="ar"><head><meta charset="utf-8">' +
                '<title>' + g.esc(title) + '</title><style>' + css + '</style></head><body>' +
                '<h1>' + g.esc(title) + '</h1>' +
                (details ? '<p class="details">' + g.esc(details) + '</p>' : '') +
                '<div class="count">عدد المستجيبين: ' + g.ends.length + '</div>' +
                body +
                '</body></html>';
            var w = window.open('', '_blank');
            if(!w){ alert('يرجى السماح بالنوافذ المنبثقة للطباعة'); return; }
            w.document.write(doc);
            w.document.close();
            w.focus();
            setTimeout(function(){ w.print(); }, 400);
        },
        // تصدير اجابات الاستبانة الى ملف Excel
        exportEnds(){
            var g = this;
            // جمع عناوين الاسئلة بترتيب ظهورها (عمود لكل سؤال)
            var titles = [];
            var seen = {};
            var parsed = g.ends.map(function(end){
                var inputs = [];
                try { inputs = JSON.parse(end.inputs); } catch(e) { inputs = []; }
                var map = {};
                inputs.forEach(function(a){
                    if(!seen[a.title]){ seen[a.title] = true; titles.push(a.title); }
                    map[a.title] = g.answerText(a.value);
                });
                return { name: end.name, date: end.date, map: map };
            });
            var header = ['الحاج', 'تاريخ الاجابة'].concat(titles);
            var rows = [header];
            parsed.forEach(function(p){
                var row = [p.name, p.date].concat(titles.map(function(t){
                    var v = p.map[t];
                    return (v === undefined || v === '—') ? '' : v;
                }));
                rows.push(row);
            });
            var ws = XLSX.utils.aoa_to_sheet(rows);
            // عرض اعمدة مناسب للاسئلة ذات الكلمات الكثيرة
            ws['!cols'] = header.map(function(h, i){
                if(i === 0) return { wch: 22 };
                if(i === 1) return { wch: 18 };
                return { wch: Math.min(60, Math.max(20, String(h).length + 5)) };
            });
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'الاجابات');
            var name = (g.currentAsk.title || 'استبانة').replace(/[\\\/:*?"<>|]/g, '_');
            XLSX.writeFile(wb, name + '_' + new Date().toLocaleDateString('en-GB').replace(/\//g, '-') + '.xlsx');
        },
    }
}
</script>

<style>

</style>